import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { getAuthors } from '../actions/authors';

const isTimeout = ({ code }) => code === 'ECONNABORTED';

export default handleAction(getAuthors, {
  first(state, { meta: { documentId } }) {
    return {
      ...state,
      [documentId]: { fetching: true }
    };
  },

  next(state, { payload, meta: { documentId } }) {
    return {
      ...state,
      [documentId]: payload.items
    };
  },

  throw(state, { payload, meta: { documentId } }) {
    return {
      ...state,
      [documentId]: { error: true, timeout: isTimeout(payload) }
    };
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/authors.js